module.exports = __webpack_public_path__ + "static/media/5.207051a1.png";